export const SEARCH_TAG_PHOTOS_LIMIT_INITIAL = 4;
export const SEARCH_TAG_PHOTOS_LIMIT_FULL = 100;
export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_URL_LOCALE = 'en-US';
export const MOBILE_BREAK_SIZE = 576;
